

































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import AppConsts from "@/lib/appconst";
import ListMixin from "@/components/mixin/list-mixin";
import { mixins } from "vue-class-component";
import columns from "./tpl-columns";
class PageTplRequest extends PageRequest {
  keyword: string;
  type: string;
}

@Component
export default class Tpl extends mixins(ListMixin, AbpBase) {
  namespace = "tpl";
  pagerequest: PageTplRequest = new PageTplRequest();
  spinShow: boolean = false;
  types = [];
  get store() {
    return this.$store.state.tpl;
  }
  getTypes() {
    this.$store
      .dispatch({
        type: "tpl/getTypesForSelect",
      })
      .then((result) => {
        result.unshift({
          code: AppConsts.allItemValue,
          description: this.L(AppConsts.All),
        });
        this.pagerequest.type = result.length === 0 ? "" : result[0].code;
        this.types = result;
      });
  }
  viewTpl(code: string) {
    this.$root.$router.push({ name: "tpl/:code", params: { code: code } });
  }
  createTpl() {
    this.$root.$router.push({ path: "create/tpl" });
  }
  updateTpl(code: string) {
    this.$root.$router.push({
      name: "update/tpl/:code",
      params: { code: code },
    });
  }
  async switchState(code: string) {
    this.$Modal.confirm({
      title: this.L("Tips"),
      content: this.L("Confirm.SwitchTplState"),
      okText: this.L("Yes"),
      cancelText: this.L("No"),
      onOk: async () => {
        this.spinShow = true;
        try {
          await this.$store
            .dispatch({
              type: "tpl/switchState",
              data: {
                id: code,
              },
            })
            .then((result) => {
              Util.showSuccessMsg(this, "Success.SwitchTplState");
              this.getpage();
            });
          this.spinShow = false;
        } catch (error) {
          this.spinShow = false;
        }
      },
    });
  }
  get list() {
    var re = this.$store.state.tpl.list;
    var startIndex = (this.currentPage - 1) * this.pageSize;
    var index = 0;
    re.forEach(function(item) {
      item.orderNo = startIndex + index + 1;
      index++;
    });
    return re;
  }
  columns = columns;
  created() {
    this.getTypes();
  }
}
